import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Course } from 'src/app/models/course';
import { MatDialog } from '@angular/material/dialog';
import { DocumentUploaderComponent } from 'src/app/components/modals/document-uploader/document-uploader.component';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-practice-content-documents',
  templateUrl: './practice-content-documents.component.html',
  styleUrls: ['./practice-content-documents.component.scss']
})
export class PracticeContentDocumentsComponent implements OnInit {
  public courseId;
  public course:Course;
  public courseLoaded:boolean=false;

  constructor(
    private _course: CourseService,
    public _dialog: MatDialog,
    private _activeRoute: ActivatedRoute,
    public _notify: MatSnackBar
  ) {
    this.courseId=this._activeRoute.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.getCourse();
  }

  public notify(message:string, action:string) {
    this._notify.open(message, action, {
      duration: 4000,
      verticalPosition: 'top'
    });
  }

  removeDocument(docId:number){
    if(!confirm('Confirm removal of this document.')) return;
    this._course.deleteDocument(docId, this.courseId).subscribe(
      res => {
        this.getCourse();
      }
    );
  }

  addDocument(){
    const dialogRef = this._dialog.open(DocumentUploaderComponent, {
      width: '450px',
      data: {courseId:this.courseId}
    });

    dialogRef.afterClosed().subscribe(res=>{
      if (res) {
        this.notify('Document uploaded.','OK');
        this.getCourse();
      }
    });
  }

  getCourse(){
    this._course.getCourse(this.courseId).subscribe(
      res=>{
        this.course=res;
        this.courseLoaded=true;
      }
    );
  }
}
